export default function NoPage() {
  return (
    <>
      <div className="app-nopage">
        <div className="no-page-wrap">
          oops!!!
          <br />
        </div>
      </div>
    </>
  );
}
